import axios from 'axios'

export async function getTokens(login, password) {
    const session_url = process.env.VUE_APP_API_URL + 'auth/admin_auth'

    const config = {
        method: 'post',
        url: session_url,
        data: {
            username: login,
            password: password
        }
    }

    const response = await axios(config)

    if (response.status == 200) {
        sessionStorage.setItem('access_token', response.data.access_token)
        sessionStorage.setItem('refresh_token', response.data.refresh_token)
        return true
    } else {
        return false
    }
}

async function rewriteTokensRequest() {
    const session_url = process.env.VUE_APP_API_URL + 'auth/admin_refresh'
    
    const config = {
        method: 'post',
        url: session_url,
        headers: { 'Authorization': 'Bearer '+ sessionStorage.getItem('refresh_token') }
    }

    let response = {}
    try {
        response = await axios(config)
    } catch (error) {
        response.status = 422
    }

    if (response.status != 200) {
        sessionStorage.removeItem('access_token')
        sessionStorage.removeItem('refresh_token')
        window.location.reload();
    } else if (response.status == 200) {
        sessionStorage.setItem('access_token', response.data.access_token)
        sessionStorage.setItem('refresh_token', response.data.refresh_token)
    }
}

async function sendApiRequest(axiosConfig) {
    axiosConfig.headers = {
        'Authorization': 'Bearer ' + sessionStorage.getItem('access_token') 
    }
    let response = {}
    try {
        response = await axios(axiosConfig)
    } catch (error) {
        response.status = 422
    }

    if (response.status != 200) {
        await rewriteTokensRequest()
        response = await axios(axiosConfig)
        return response
    } else if (response.status == 200) {
        return response
    }
}

async function sendApiRequestReturnData(axiosConfig) {
    const response = await sendApiRequest(axiosConfig)
    return response.data
}

function formatDate(date) {
    let month = '' + (date.getMonth() + 1),
        day = '' + date.getDate(),
        year = date.getFullYear()

    if (month.length < 2) month = '0' + month
    if (day.length < 2) day = '0' + day

    return [year, month, day].join('-')
}

export const getAllLocations = async () => {
    const session_url = process.env.VUE_APP_API_URL + 'location/get_all_locations'

    const config = {
        method: 'get',
        url: session_url,
    }

    return await sendApiRequest(config)
}

export const getAllGroups = async () => {
    const session_url = process.env.VUE_APP_API_URL + 'groups/get_all_groups'

    const config = {
      method: 'get',
      url: session_url,
    }
    
    return await sendApiRequest(config)
}

export const addNewTraining = async (groupName, groupId, locationName, locationId, startTime, endTime, date, trainingType, description, trainer_id, trainer_label, additional_files) => {
    const session_url = process.env.VUE_APP_API_URL + 'trainings/add_new_training'
    let formattedDate = null

    if (typeof date === 'string') {
        formattedDate = (new Date(date)).toISOString()
    } else {
        formattedDate = (new Date(formatDate(date))).toISOString()
    }

    const data = {
        group_id: groupId,
        group_label: groupName,
        date: formattedDate,
        start_time: startTime,
        end_time: endTime,
        location_id: locationId,
        location_label: locationName,
        type: trainingType,
        description: description,
        trainer_id: trainer_id,
        trainer_label: trainer_label
    }

    const formData = new FormData()

    formData.append('training', JSON.stringify(data))   

    additional_files.forEach((file) => {
        formData.append('additional_files', file)
    })

    const config = {
        method: 'post',
        url: session_url,
        data: formData
    }
    
    return await sendApiRequest(config)
}

export const getAllTrainings = async () => {
    const session_url = process.env.VUE_APP_API_URL + 'trainings/get_all_trainings'
    const config = {
        method: 'get',
        url: session_url
    }
    return await sendApiRequest(config)
}

export const updateTraining = async (trainingId, groupName, groupId, locationName, locationId, startTime, endTime, date, type, description, trainer_id, trainer_label, old_additional_files, new_additional_files, selectedSummary) => {
    const session_url = process.env.VUE_APP_API_URL + 'trainings/update_training_by_id'
    
    let formattedDate = null

    if (typeof date === 'string') {
        formattedDate = (new Date(date + ' GMT')).toISOString()
    } else {
        formattedDate = (new Date(formatDate(date) + ' GMT')).toISOString()
    }
    
    const data = {
        group_id: groupId,
        group_label: groupName,
        date: formattedDate,
        start_time: startTime,
        end_time: endTime,
        location_id: locationId,
        location_label: locationName,
        type: type,
        description: description,
        trainer_id: trainer_id,
        trainer_label: trainer_label,
        summary: selectedSummary
    }

    const formData = new FormData()

    formData.append('training', JSON.stringify(data))

    old_additional_files.forEach((file) => {
        formData.append('old_additional_files', file)
    })

    new_additional_files.forEach((file) => {
        formData.append('new_additional_files', file)
    })

    const config = {
        method: 'put',
        url: session_url + '?training_id=' + trainingId,
        data: formData
    }
    return await sendApiRequest(config)
}

export const getLocationById = async (locationId) => {
    const session_url = process.env.VUE_APP_API_URL + 'location/get_location_by_id'
    const config = {
        method: 'get',
        url: session_url + '?location_id=' + locationId,
        params: {
            location_id: locationId
        }
    }
    return await sendApiRequest(config)
}

export const getGroupById = async (groupId) => {
    const session_url = process.env.VUE_APP_API_URL + 'groups/get_group_by_id'
    const config = {
        method: 'get',
        url: session_url + '?group_id=' + groupId,
        params: {
            group_id: groupId
        }
    }
    return await sendApiRequest(config)
}

export const deleteTrainingById = async (trainingId) => {
    const session_url = process.env.VUE_APP_API_URL + 'trainings/delete_training_by_id'

    const config = {
        method: 'delete',
        url: session_url,
        params: {
            training_id: trainingId
        }
    }

    return await sendApiRequest(config)
}

export const getAllTrainers = async () => {
    const session_url = process.env.VUE_APP_API_URL + 'trainer/get_all_trainers'
    const config = {
      method: 'get',
      url: session_url
    }
    return await sendApiRequest(config)
}

export const addNewGroup = async (groupName, groupYearRange, trainerId, paymentStatus) => {
    const session_url = process.env.VUE_APP_API_URL + 'groups/add_new_group'
    const config = {
        method: 'post',
        url: session_url,
        data: {
            name: groupName,
            year_range: groupYearRange,
            trainer_id: trainerId,
            payment_status: paymentStatus
        }
    }
    return await sendApiRequest(config)
}

export const getTrainerById = async (trainerId) => {
    const session_url = process.env.VUE_APP_API_URL + 'trainer/get_trainer_by_id'
    const config = {
        method: 'get',
        url: session_url,
        params: {
            trainer_id: trainerId
        }
    }
    return await sendApiRequest(config)
}

export const getAllStudents = async (count = 100, skip = 0, balance_sort = null, query = null, startAgeRange = null, endAgeRange = null, status = ['active']) => {
    console.log('status -------- ', status)
    const session_url = process.env.VUE_APP_API_URL + 'student/get_all_students'
    const config = {
      method: 'post',
      url: session_url,

      data: {
            count: count,
            skip: skip,
            balance_sort: balance_sort,
            query: query,
            age_from: startAgeRange,
            age_to: endAgeRange,
            status: status
      }
    }
    return await sendApiRequest(config)
}

export const addGroupToStudents = async (studentsIds, groupId, groupName) => {
    const session_url = process.env.VUE_APP_API_URL + 'groups/add_list_of_students_to_group'

    const config = {
        method: 'post',
        url: session_url,
        params: {
            group_id: groupId,
            group_name: groupName
        },
        data: studentsIds
    }

    return await sendApiRequest(config)
}

export const getStudentsCountByGroupId = async (groupId) => {
    const session_url = process.env.VUE_APP_API_URL + 'groups/get_number_of_students_by_group_id'
    
    const config = {
        method: 'get',
        url: session_url,
        params: {
            group_id: groupId
        }
    }

    return await sendApiRequest(config)
}

export const updateGroupRequest = async (groupId, groupName, groupYearRange, trainerId, paymentStatus, currentAssistants) => {
    const session_url = process.env.VUE_APP_API_URL + 'groups/update_group'

    const config = {
        method: 'put',
        url: session_url,
        params: {
            group_id: groupId,
        },
        data: {
            name: groupName,
            year_range: groupYearRange,
            trainer_id: trainerId,
            payment_status: paymentStatus,
            assistants: currentAssistants
        }
    }

    return await sendApiRequest(config)
}

export const deleteGroupRequest = async (groupId) => {
    const session_url = process.env.VUE_APP_API_URL + 'groups/delete_group'

    const config = {
        method: 'delete',
        url: session_url,
        params: {
            group_id: groupId,
        }
    }

    return await sendApiRequest(config)
}


export const addNewLocation = async (locationName, smallLocationName, locationAddress, locationDescription, geoUrl, locationPhoto) => {
    const session_url = process.env.VUE_APP_API_URL + 'location/add_new_location'

    const formData = new FormData()
    formData.append('location', JSON.stringify({
        name: locationName,
        address: locationAddress,
        description: locationDescription,
        small_name: smallLocationName,
        geo_url: geoUrl
    }))
    formData.append('location_picture', locationPhoto)

    const config = {
        method: 'post',
        url: session_url,
        data: formData,
    }

    return await sendApiRequest(config)
}

export const updateLocation = async (locationId, locationName, smallLocationName, locationAddress, locationDescription, geoUrl, locationPhoto) => {
    const session_url = process.env.VUE_APP_API_URL + 'location/update_location_by_id'

    const formData = new FormData()
    formData.append('location', JSON.stringify({
        name: locationName,
        address: locationAddress,
        description: locationDescription,
        small_name: smallLocationName,
        geo_url: geoUrl
    }))
    formData.append('location_picture', locationPhoto)

    const config = {
        method: 'put',
        url: session_url + '?location_id=' + locationId,
        data: formData
    }
    return await sendApiRequest(config)
}

export const deleteCurrentLocation = async (locationId) => {
    const session_url = process.env.VUE_APP_API_URL + 'location/delete_location_by_id'

    const config = {
        method: 'delete',
        url: session_url + '?location_id=' + locationId
    }

    return await sendApiRequest(config)
}

export const getAdmin = async () => {
    const session_url = process.env.VUE_APP_API_URL + 'admin/get_admin'
    const config = {
      method: 'get',
      url: session_url
    }
    return await sendApiRequest(config)
}

function dataURItoBlob(dataURI) {
    var byteString = atob(dataURI.split(',')[1]);
  
    var mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];
  
    var ab = new ArrayBuffer(byteString.length);
    var ia = new Uint8Array(ab);
    for (var i = 0; i < byteString.length; i++) {
        ia[i] = byteString.charCodeAt(i);
    }

    return new Blob([ab], {type: mimeString});
}
  
export const addNewStudent = async (new_student_obj, photo) => {
    const session_url = process.env.VUE_APP_API_URL + 'student/add_new_student'
    new_student_obj.birthday = new_student_obj.birthday.length == 0 ? new Date().toISOString() : new Date(new_student_obj.birthday).toISOString()
    new_student_obj.start_training = new_student_obj.start_training.length == 0 ? new Date().toISOString() : new Date(new_student_obj.start_training).toISOString()
    new_student_obj.passport_end_date = new_student_obj.passport_end_date.length == 0 ? new Date().toISOString() : new Date(new_student_obj.passport_end_date).toISOString()

    const formData = new FormData()
    
    if (photo !== null) {
        formData.append('student_picture', dataURItoBlob(photo))
    } else {
        formData.append('student_picture', null)
    }

    new_student_obj.id_photos?.forEach((id_photo, index) => {
        formData.append(`id_photos`, id_photo)
    })

    new_student_obj.passport_photos?.forEach((passport_photo, index) => {
        formData.append(`passport_photos`, passport_photo)
    })

    new_student_obj.attorney_files?.forEach((attorney_file, index) => {
        formData.append(`attorney_files`, attorney_file)
    })

    new_student_obj.photo_for_passport?.forEach((photo_for_passport_file, index) => {
        formData.append(`photo_for_passport`, photo_for_passport_file)
    })

    delete new_student_obj.id_photos
    delete new_student_obj.passport_photos
    delete new_student_obj.attorney_files
    delete new_student_obj.photo_for_passport
    
    formData.append('new_student', JSON.stringify(new_student_obj))

    const config = {
        method: 'post',
        url: session_url,
        data: formData
    }
    return await sendApiRequest(config)
}

export const deleteStudent = async (student_id) => {
    const session_url = process.env.VUE_APP_API_URL + 'student/delete_student'
    const config = {
        method: 'delete',
        url: session_url,
        params: {
            student_id: student_id
        }
    }
    return await sendApiRequest(config)
}

export const updateStudent = async (student_obj, photo, idPhotos, passportPhotos, attorneyFiles, photoForPassport) => {
    const session_url = process.env.VUE_APP_API_URL + 'student/update_student'

    student_obj.birthday = new Date(student_obj.birthday).toISOString()
    student_obj.start_training = new Date(student_obj.start_training).toISOString()
    student_obj.passport_end_date = new Date(student_obj.passport_end_date).toISOString()

    const formData = new FormData()
    if (photo !== null && photo.startsWith('data')) {
        formData.append('student_picture', dataURItoBlob(photo))
    } else {
        formData.append('student_picture', null)
    }

    idPhotos.forEach((id_photo, index) => {
        formData.append(`id_photos`, id_photo)
    })

    passportPhotos.forEach((passport_photo, index) => {
        formData.append(`passport_photos`, passport_photo)
    })

    attorneyFiles.forEach((attorney_file, index) => {
        formData.append(`attorney_files`, attorney_file)
    })

    photoForPassport.forEach((photo_for_passport_file, index) => {
        formData.append(`photo_for_passport`, photo_for_passport_file)
    })

    formData.append('updated_student', JSON.stringify(student_obj))

    const config = {
        method: 'put',
        url: session_url,
        data: formData,
        params: {
            student_id: student_obj.id
        }
    }

    return await sendApiRequest(config)
}

export const getStudentById = async (student_id) => {
    const session_url = process.env.VUE_APP_API_URL + 'student/get_student_by_id'

    const config = {
        method: 'get',
        url: session_url,
        params: {
            student_id: student_id
        }
    }

    return await sendApiRequest(config)
}

export const sendPhotoToRemoveBg = async (blob) => {
    const formData = new FormData();
    formData.append('file', blob);
    
    const response = await axios(
        {
            url: 'https://api.carpediem.pp.ua/subservice/removebg',
            method: 'POST',
            responseType: 'blob', 
            data: formData,
        }
    )

    return new Blob([response.data])
}

export const getBalanceState = async (balance_id) => {
    const config = {
        method: 'get',
        url: process.env.VUE_APP_API_URL + 'balance/get_balance_state',
        params: {
            balance_id: balance_id
        }
    }
    const response = await sendApiRequestReturnData(config)
    return response.balance_state
}

export const getAllIncomes = async (balance_id) => {
    const config = {
        method: 'get',
        url: process.env.VUE_APP_API_URL + 'transaction/get_all_virtual_incomes_by_balance_id',
        params: {
            balance_id: balance_id,
            year: new Date().getFullYear()
        }
    }
    return await sendApiRequestReturnData(config)
}

export const getAllOutlays = async (balance_id, year) => {
    const config = {
        method: 'get',
        url: process.env.VUE_APP_API_URL + 'transaction/get_all_virtual_outlay_by_balance_id',
        params: {
            balance_id: balance_id,
            year: year
        }
    }
    const response = await sendApiRequestReturnData(config)
    return response
}

export const deleteTrainerRequest = async (trainer_id) => {
  const session_url = process.env.VUE_APP_API_URL + 'trainer/delete_trainer_by_id'

  const config = {
      method: 'delete',
      url: session_url,
      params: {
          trainer_id: trainer_id
      }
  }

  return await sendApiRequest(config)
}

export const addNewTrainer = async (new_trainer_obj, photo) => {
    const session_url = process.env.VUE_APP_API_URL + 'trainer/add_new_trainer'

    new_trainer_obj.birthday = isNaN(new Date(new_trainer_obj.birthday)) ? null : new Date(new_trainer_obj.birthday).toISOString() 
    new_trainer_obj.club_start_date = isNaN(new Date(new_trainer_obj.club_start_date)) ? null : new Date(new_trainer_obj.club_start_date).toISOString() 
    new_trainer_obj.passport_end_date = isNaN(new Date(new_trainer_obj.passport_end_date)) ? null : new Date(new_trainer_obj.passport_end_date).toISOString()
    new_trainer_obj.issuing_date = isNaN(new Date(new_trainer_obj.issuing_date)) ? null : new Date(new_trainer_obj.issuing_date).toISOString()

    const formData = new FormData()
    
    if (photo !== null) {
        formData.append('trainer_picture', dataURItoBlob(photo))
    } else {
        formData.append('trainer_picture', null)
    }

    new_trainer_obj.id_photos.forEach((id_photo, index) => {
        formData.append('id_photos', id_photo)
    })

    new_trainer_obj.passport_photos.forEach((passport_photo, index) => {
        formData.append('passport_photos', passport_photo)
    })

    new_trainer_obj.ukrainian_passport_files.forEach((ukrainian_passport, index) => {
        formData.append('ukrainian_passport_files', ukrainian_passport)
    })

    delete new_trainer_obj.id_photos
    delete new_trainer_obj.passport_photos
    delete new_trainer_obj.ukrainian_passport_files
    
    formData.append('new_trainer', JSON.stringify(new_trainer_obj))

    const config = {
        method: 'post',
        url: session_url,
        data: formData
    }
    return await sendApiRequest(config)
}

export const updateTrainer = async (updated_trainer_obj, trainer_photo, passportPhotos, idCodePhotos, ukrainianPassportPhotos) => {
    const session_url = process.env.VUE_APP_API_URL + 'trainer/update_trainer'

    updated_trainer_obj.birthday = new Date(updated_trainer_obj.birthday).toISOString()
    updated_trainer_obj.club_start_date = new Date(updated_trainer_obj.club_start_date).toISOString()
    updated_trainer_obj.passport_end_date = new Date(updated_trainer_obj.passport_end_date).toISOString()
    updated_trainer_obj.issuing_date = new Date(updated_trainer_obj.issuing_date).toISOString()

    const formData = new FormData()

    if (trainer_photo !== null && trainer_photo.startsWith('data:image')) {
        formData.append('trainer_picture', dataURItoBlob(trainer_photo))
    }

    idCodePhotos.forEach((id_photo, index) => {
        formData.append('id_photos', id_photo)
    })

    passportPhotos.forEach((passport_photo, index) => {
        formData.append('passport_photos', passport_photo)
    })

    ukrainianPassportPhotos.forEach((ukrainian_passport, index) => {
        formData.append('ukrainian_passport_files', ukrainian_passport)
    })

    formData.append('updated_trainer', JSON.stringify(updated_trainer_obj))


    delete updated_trainer_obj.id_photos
    delete updated_trainer_obj.passport_photos
    delete updated_trainer_obj.ukrainian_passport_files

    const config = {
        method: 'put',
        url: session_url,
        data: formData
    }

    return await sendApiRequest(config)
}

export const getGroupsByTrainerId = async (trainer_id) => {
    const session_url = process.env.VUE_APP_API_URL + 'trainer/get_trainer_groups_by_trainer_id'

    const config = {
        method: 'get',
        url: session_url,
        params: {
            trainer_id: trainer_id
        }
    }

    return await sendApiRequest(config)
}

export const getActiveStudentsInGroup = async (group_id) => {
    const session_url = process.env.VUE_APP_API_URL + 'groups/get_active_students_in_group'

    const config = {
        method: 'get',
        url: session_url,
        params: {
            group_id: group_id
        }
    }

    return await sendApiRequest(config)
}

export const getPlanedTrainingsByGroup = async (group_id) => {
    const currentDate = new Date()

    const config = {
        method: 'get',
        url: process.env.VUE_APP_API_URL + 'trainings/get_planed_trainings_by_group',
        params: {
            group_id: group_id,
            current_date: currentDate.toISOString()
        }
    }

    return await sendApiRequestReturnData(config)
}

export const getServiceBalanceByLabel = async (label) => {
    const config = {
        method: 'get',
        url: process.env.VUE_APP_API_URL + 'balance/get_service_balance_by_label',
        params: {
            service_label: label
        }
    }
    return await sendApiRequestReturnData(config)
}

export const getCertainNumberOfIncomes = async (number_of_transactions, skip = 0, filters = null) => {
    filters = filters === null ? {
        receiver_type: 'all',
        transaction_type: 'all',
        amount_from: null,
        amount_to: null,
        date_from: null,
        date_to: null,
        current_balance_id: null,
        current_transaction_id: null
    } : filters


    const config = {
        method: 'get',
        url: process.env.VUE_APP_API_URL + 'transaction/get_certain_number_of_incomes',
        params: {
            count: number_of_transactions,
            skip: skip,
            filters: JSON.stringify(filters)
        },
    }

    return await sendApiRequestReturnData(config)
}

export const getBalanceObject = async (balance_id) => {
    const config = {
        method: 'get',
        url: process.env.VUE_APP_API_URL + 'balance/get_balance_object_by_id',
        params: {
            balance_id: balance_id
        }
    }

    return await sendApiRequestReturnData(config)
}

export const getVirtualIncomeById = async (transaction_id) => {
    const config = {
        method: 'get',
        url: process.env.VUE_APP_API_URL + 'transaction/get_virtual_income_by_id',
        params: {
            transaction_id: transaction_id
        }
    }

    return await sendApiRequestReturnData(config)
}

export const getUniversalTransactionById = async (transaction_id) => {
    const config = {
        method: 'get',
        url: process.env.VUE_APP_API_URL + 'transaction/get_universal_transaction_by_id',
        params: {
            transaction_id: transaction_id
        }
    }

    return await sendApiRequestReturnData(config)
}

export const getUniversalTransactionByBalanceId = async (balance_id) => {
    const config = {
        method: 'get',
        url: process.env.VUE_APP_API_URL + 'transaction/get_all_universal_transactions_by_balance_id',
        params: {
            balance_id: balance_id
        }
    }

    return await sendApiRequestReturnData(config)
}

export const getRealParentTransactionByVirtualTransactionId = async (transaction_id) => {
    const config = {
        method: 'get',
        url: process.env.VUE_APP_API_URL + 'transaction/get_real_parent_transaction_by_virtual_transaction_id',
        params: {
            transaction_id: transaction_id
        }
    }

    return await sendApiRequestReturnData(config)
}

export const getAllVirtualBalances = async () => {
    const config = {
        method: 'get',
        url: process.env.VUE_APP_API_URL + 'balance/get_all_virtual_balances'
    }

    return await sendApiRequestReturnData(config)
}

export const addVirtualIncomeRequest = async (balanceId, amount, label) => {
    const session_url = process.env.VUE_APP_API_URL + 'transaction/add_virtual_income'

    const formData = new FormData()

    const txConfig = {
        receiver_balance_id: balanceId,
        amount: amount,
        label: label
    }
    formData.append('virtual_income', JSON.stringify(txConfig))

    const config = {
        method: 'post',
        url: session_url,
        data: formData
    }

    return await sendApiRequest(config)
}

export const addRealIncomeRequest = async (balanceId, amount, label, virtualTxId, images) => {
    const session_url = process.env.VUE_APP_API_URL + 'transaction/add_real_income'

    const formData = new FormData()

    const txConfig = {
        receiver_balance_id: balanceId,
        amount: amount,
        label: label,
        embed_virtual_income: virtualTxId
    }

    formData.append('real_income', JSON.stringify(txConfig))

    images.forEach((image) => {
        formData.append('additional_files', image)
    })

    const config = {
        method: 'post',
        url: session_url,
        data: formData
    }

    return await sendApiRequest(config)
}

export const getServiceBalanceObjectByLabel = async (label) => {
    const config = {
        method: 'get',
        url: process.env.VUE_APP_API_URL + 'balance/get_service_balance_object_by_label',
        params: {
            service_label: label
        }
    }

    return await sendApiRequestReturnData(config)
}

export const getAllTrainerStudentBalanceState = async () => {
    const config = {
        method: 'get',
        url: process.env.VUE_APP_API_URL + 'balance/get_all_trainers_student_balance_states'
    }

    return await sendApiRequestReturnData(config)
}

export const getCertainNumberOfOutlays = async (number_of_transactions, skip = 0, filters = null) => {
    filters = filters === null ? {
        sender_type: 'all',
        transaction_type: 'all',
        amount_from: null,
        amount_to: null,
        date_from: null,
        date_to: null,
        current_balance_id: null,
        current_transaction_id: null
    } : filters

    const config = {
        method: 'get',
        url: process.env.VUE_APP_API_URL + 'transaction/get_certain_number_of_outlays',
        params: {
            count: number_of_transactions,
            skip: skip,
            filters: JSON.stringify(filters)
        }
    }

    return await sendApiRequestReturnData(config)
}

export const getIncomeTransactionById = async (transaction_id) => {
    const config = {
        method: 'get',
        url: process.env.VUE_APP_API_URL + 'transaction/get_income_transaction_by_id',
        params: {
            transaction_id: transaction_id
        }
    }

    return await sendApiRequestReturnData(config)
}

export const getIncomeTransactionByBalanceId = async (balance_id) => {
    const config = {
        method: 'get',
        url: process.env.VUE_APP_API_URL + 'transaction/get_all_income_transactions_by_balance_id',
        params: {
            balance_id: balance_id
        }
    }

    return await sendApiRequestReturnData(config)
}

export const getOutlayTransactionById = async (transaction_id) => {
    const config = {
        method: 'get',
        url: process.env.VUE_APP_API_URL + 'transaction/get_outlay_transaction_by_id',
        params: {
            transaction_id: transaction_id
        }
    }

    return await sendApiRequestReturnData(config)
}

export const getOutlayTransactionByBalanceId = async (balance_id) => {
    const config = {
        method: 'get',
        url: process.env.VUE_APP_API_URL + 'transaction/get_all_outlay_transactions_by_balance_id',
        params: {
            balance_id: balance_id
        }
    }

    return await sendApiRequestReturnData(config)
}

export const getSumOfAllVirtualOutlays = async () => {
    const config = {
        method: 'get',
        url: process.env.VUE_APP_API_URL + 'transaction/get_sum_of_all_virtual_outlays'
    }

    return await sendApiRequestReturnData(config)
}

export const getAllVirtualOutlaysCount = async () => {
    const config = {
        method: 'get',
        url: process.env.VUE_APP_API_URL + 'transaction/get_all_virtual_outlays_count'
    }

    return await sendApiRequestReturnData(config)
}

export const getMeanRealIncomeFromStudent = async () => {
    const config = {
        method: 'get',
        url: process.env.VUE_APP_API_URL + 'transaction/get_mean_real_income_from_student'
    }

    return await sendApiRequestReturnData(config)
}

export const getYearIncomesBySources = async (year) => {
    const config = {
        method: 'get',
        url: process.env.VUE_APP_API_URL + 'statistic/get_incomes_by_sources_by_year',
        params: {
            year: year
        }
    }

    return await sendApiRequestReturnData(config)
}

export const getIncomesBySourcesByMonth = async (year, month) => {
    const config = {
        method: 'get',
        url: process.env.VUE_APP_API_URL + 'statistic/get_incomes_by_sources_by_month_and_year',
        params: {
            year: year,
            month: month
        }
    }

    return await sendApiRequestReturnData(config)
}

export const getIncomesByGroups = async (year, month) => {
    const config = {
        method: 'get',
        url: process.env.VUE_APP_API_URL + 'statistic/get_incomes_by_groups',
        params: {
            year: year,
            month: month
        }
    }

    return await sendApiRequestReturnData(config)
}

export const getAllCompletedTrainingsByStudentId = async (student_id) => {
    const config = {
        method: 'get',
        url: process.env.VUE_APP_API_URL + 'trainings/get_students_completed_trainings',
        params: {
            student_id: student_id
        }
    }

    return await sendApiRequestReturnData(config)
}

export const getAllStudentsListInGroup = async (group_id) => {
    const config = {
        method: 'get',
        url: process.env.VUE_APP_API_URL + 'groups/get_all_students_list_in_group',
        params: {
            group_id: group_id
        }
    }

    return await sendApiRequestReturnData(config)
}

export const getStudentsCount = async () => {
    const config = {
        method: 'get',
        url: process.env.VUE_APP_API_URL + 'student/get_students_count'
    }

    return await sendApiRequestReturnData(config)
}

export const getAllTransactions = async () => {
    const config = {
        method: 'get',
        url: process.env.VUE_APP_API_URL + 'transaction/get_all_transactions'
    }

    return await sendApiRequestReturnData(config)
}

export const getBalanceByQuery = async (query) => {
    const config = {
        method: 'get',
        url: process.env.VUE_APP_API_URL + 'balance/get_balance_by_query',
        params: {
            query: query
        }
    }

    return await sendApiRequestReturnData(config)
}

export const addRealTransactionRequest = async (senderBalanceId, receiverBalanceId, amount, label, images) => {
    const session_url = process.env.VUE_APP_API_URL + 'transaction/add_real_transaction'

    const formData = new FormData()

    const txConfig = {
        receiver_balance_id: receiverBalanceId,
        sender_balance_id: senderBalanceId,
        amount: amount,
        label: label
    }
    console.log('txConfig ------- ', txConfig)
    formData.append('real_transaction', JSON.stringify(txConfig))

    images.forEach((image) => {
        formData.append('additional_files', image)
    })

    const config = {
        method: 'post',
        url: session_url,
        data: formData
    }

    return await sendApiRequest(config)
}

export const getAllAdmins = async () => {
    const config = {
        method: 'get',
        url: process.env.VUE_APP_API_URL + 'admin/get_all_admins'
    }

    return await sendApiRequestReturnData(config)
}

export const getAllCashFromAdmins = async () => {
    const config = {
        method: 'get',
        url: process.env.VUE_APP_API_URL + 'balance/get_all_cash_from_admins'
    }

    return await sendApiRequestReturnData(config)
}

export const getAllInvestFromAdmins = async () => {
    const config = {
        method: 'get',
        url: process.env.VUE_APP_API_URL + 'balance/get_all_invest_from_admins'
    }

    return await sendApiRequestReturnData(config)
}

export const getCountOfIncomes = async (filters) => {
    const config = {
        method: 'get',
        url: process.env.VUE_APP_API_URL + 'transaction/get_count_of_incomes',
        body: filters
    }

    return await sendApiRequestReturnData(config)
}

export const addOutlayCategory = async (name, id) => {
    console.log('name ------- ', name)

    const formData = new FormData()

    formData.append('name', name)

    const config = {
        method: 'post',
        url: process.env.VUE_APP_API_URL + 'outlay_category/add_outlay_category',
        data: {
            name : name,
            id: id
        }
    }

    return await sendApiRequestReturnData(config)
}

export const addOutlaySubcategory = async (name, outlayCategoryId, id) => {
    const config = {
        method: 'post',
        url: process.env.VUE_APP_API_URL + 'outlay_category/add_subcategory',
        data: {
            name: name,
            embed_category_id: outlayCategoryId,
            id: id
        }
    }

    return await sendApiRequestReturnData(config)
}

export const getAllOutlayCategoriesWithSubcategories = async () => {
    const config = {
        method: 'get',
        url: process.env.VUE_APP_API_URL + 'outlay_category/get_all_categories_with_subcategories'
    }

    return await sendApiRequestReturnData(config)
}

export const getAllOutlayCategories = async () => {
    const config = {
        method: 'get',
        url: process.env.VUE_APP_API_URL + 'outlay_category/get_all_categories'
    }

    return await sendApiRequestReturnData(config)
}

export const getSubcategoriesByCategoryId = async (id) => {
    const config = {
        method: 'get',
        url: process.env.VUE_APP_API_URL + 'outlay_category/get_subcategories_by_category_id',
        params: {
            category_id: id
        }
    }

    return await sendApiRequestReturnData(config)
}

export const addRealOutlay = async (
        amount, 
        date, 
        label, 
        name, 
        senderBalanceId, 
        senderBalanceName, 
        categoryId, 
        categoryName, 
        subcategoryId, 
        subcategoryName, 
        creatorId, 
        creatorName, 
        images) => {
    const session_url = process.env.VUE_APP_API_URL + 'transaction/add_real_outlay'

    const formData = new FormData()

    const txConfig = {
        amount: amount,
        date: date,
        label: label,
        name: name,
        sender_balance_id: senderBalanceId,
        sender_balance_name: senderBalanceName,
        category_id: categoryId,
        category_name: categoryName,
        subcategory_id: subcategoryId,
        subcategory_name: subcategoryName,
        creator_id: creatorId,
        creator_name: creatorName
    }

    formData.append('real_outlay', JSON.stringify(txConfig))

    images.forEach((image) => {
        formData.append('additional_files', image)
    })

    const config = {
        method: 'post',
        url: session_url,
        data: formData
    }

    return await sendApiRequest(config)
}

export const getRealOutlays = async () => {
    const config = {
        method: 'get',
        url: process.env.VUE_APP_API_URL + 'transaction/get_real_outlays',
    }

    return await sendApiRequestReturnData(config)
}

export const deleteCategoryById = async (id) => {
    const config = {
        method: 'delete',
        url: process.env.VUE_APP_API_URL + 'outlay_category/delete_category_by_id',
        params: {
            category_id: id
        }
    }

    return await sendApiRequestReturnData(config)
}

export const deleteSubcategoryById = async (id) => {
    const config = {
        method: 'delete',
        url: process.env.VUE_APP_API_URL + 'outlay_category/delete_subcategory_by_id',
        params: {
            subcategory_id: id
        }
    }

    return await sendApiRequestReturnData(config)
}

export const updateCategoryById = async (id, name) => {
    const config = {
        method: 'put',
        url: process.env.VUE_APP_API_URL + 'outlay_category/update_category_by_id',
        params: {
            category_id: id,
            category_name: name
        }
    }

    return await sendApiRequestReturnData(config)
}

export const updateSubcategoryById = async (id, name) => {
    const config = {
        method: 'put',
        url: process.env.VUE_APP_API_URL + 'outlay_category/update_subcategory_by_id',
        params: {
            subcategory_id: id,
            subcategory_name: name
        }
    }

    return await sendApiRequestReturnData(config)
}

export const getRealOutlaysByFilters = async (count, skip, filters) => {
    console.log('filters ------- ', filters)
    const config = {
        method: 'get',
        url: process.env.VUE_APP_API_URL + `transaction/get_certain_number_of_club_outlays`,
        params: {
            count: count,
            skip: skip,
            filters: JSON.stringify(filters)
        }
    }

    return await sendApiRequestReturnData(config)
}

export const getCountOfClubOutlays = async (filters) => {
    const config = {
        method: 'get',
        url: process.env.VUE_APP_API_URL + 'transaction/get_count_of_club_outlays',
        params: {
            filters: JSON.stringify(filters)
        }
    }

    return await sendApiRequestReturnData(config)
}

export const deleteClubOutlay = async (id) => {
    const config = {
        method: 'delete',
        url: process.env.VUE_APP_API_URL + 'transaction/delete_club_outlay',
        params: {
            transaction_id: id
        }
    }

    return await sendApiRequestReturnData(config)
}

export const updateClubOutlay = async (tx_id, new_outlay, additional_files) => {
    const formData = new FormData()

    formData.append('real_outlay', JSON.stringify(new_outlay))

    additional_files.forEach((file) => {
        formData.append('additional_files', file)
    })

    const config = {
        method: 'put',
        url: process.env.VUE_APP_API_URL + 'transaction/update_club_outlay',
        params: {
            transaction_id: tx_id
        },
        data: formData
    }

    return await sendApiRequestReturnData(config)
}

export const getStatisticsClubOutlaysByYear = async (year) => {
    const config = {
        method: 'get',
        url: process.env.VUE_APP_API_URL + 'statistic/get_club_outlays_by_year',
        params: {
            year: year
        }
    }

    return await sendApiRequestReturnData(config)
}

export const getGroupsAttendanceByYearAndMonth = async (year, month) => {
    const session_url = process.env.VUE_APP_API_URL + 'statistic/get_groups_attendance_by_month_and_year'

    const config = {
        method: 'get',
        url: session_url,
        params: {
            year: year,
            month: month
        }
    }

    return await sendApiRequestReturnData(config)
}

export const getTrainerCompletedTrainingsByYear = async (year, trainer_id) => {
    const session_url = process.env.VUE_APP_API_URL + 'trainings/get_trainer_completed_trainings_by_year'

    const config = {
        method: 'get',
        url: session_url,
        params: {
            year: year,
            trainer_id: trainer_id
        }
    }

    return await sendApiRequest(config)
}

export const getAllIncomesByGroupInYear = async (year) => {
    const session_url = process.env.VUE_APP_API_URL + 'statistic/get_incomes_by_groups_by_year'

    const config = {
        method: 'get',
        url: session_url,
        params: {
            year: year
        }
    }

    return await sendApiRequest(config)
}

export const getActiveStudentsCount = async () => {
    const session_url = process.env.VUE_APP_API_URL + 'student/get_active_students_count'

    const config = {
        method: 'get',
        url: session_url
    }

    return await sendApiRequestReturnData(config)
}

export const getDebtStudentsCount = async () => {
    const session_url = process.env.VUE_APP_API_URL + 'student/get_debt_students_count'

    const config = {
        method: 'get',
        url: session_url
    }

    return await sendApiRequestReturnData(config)
}

export const getArchiveStudentsCount = async () => {
    const session_url = process.env.VUE_APP_API_URL + 'student/get_archive_students_count'

    const config = {
        method: 'get',
        url: session_url
    }

    return await sendApiRequestReturnData(config)
}

export const addStudentToArchive = async (student_id) => {
    const session_url = process.env.VUE_APP_API_URL + 'student/add_student_to_archive'

    const config = {
        method: 'post',
        url: session_url,
        params: {
            student_id: student_id
        }
    }

    return await sendApiRequestReturnData(config)
}

export const removeStudentFromArchive = async (student_id) => {
    const session_url = process.env.VUE_APP_API_URL + 'student/remove_student_from_archive'

    const config = {
        method: 'post',
        url: session_url,
        params: {
            student_id: student_id
        }
    }

    return await sendApiRequestReturnData(config)
}

export const getRealIncomesByBalanceIdRequest = async (balanceId) => {
    const session_url = process.env.VUE_APP_API_URL + 'transaction/get_all_real_incomes_by_balance_id'

    const config = {
        method: 'get',
        url: session_url,
        params: {
            balance_id: balanceId
        }
    }

    return await sendApiRequest(config)
}

export const getTransactionsByBalanceIdRequest = async (balanceId) => {
    const session_url = process.env.VUE_APP_API_URL + 'transaction/get_transactions_by_balance_id'

    const config = {
        method: 'get',
        url: session_url,
        params: {
            balance_id: balanceId
        }
    }

    return await sendApiRequest(config)
}

export const getAllSettings = async () => {
    const session_url = process.env.VUE_APP_API_URL + 'settings/get_settings'

    const config = {
        method: 'get',
        url: session_url
    }

    return await sendApiRequestReturnData(config)
}

export const updateSettingsRequest = async (settings) => {
    const session_url = process.env.VUE_APP_API_URL + 'settings/update_settings'

    const config = {
        method: 'post',
        url: session_url,
        data: settings
    }

    return await sendApiRequestReturnData(config)
}

export const addTariffRoleRequest = async (tariffRole) => {
    const session_url = process.env.VUE_APP_API_URL + 'tariffs/add_new_tariff_role'

    const config = {
        method: 'post',
        url: session_url,
        data: tariffRole
    }

    return await sendApiRequestReturnData(config)
}

export const getAllTariffRolesRequest = async () => {
    const session_url = process.env.VUE_APP_API_URL + 'tariffs/get_all_tariff_roles'

    const config = {
        method: 'get',
        url: session_url
    }

    return await sendApiRequestReturnData(config)
}

export const updateTariffRoleRequest = async (tariffRole) => {
    const session_url = process.env.VUE_APP_API_URL + 'tariffs/update_tariff_role_by_id'

    const config = {
        method: 'put',
        url: session_url,
        params: {
            tariff_role_id: tariffRole.id
        },
        data: tariffRole
    }

    return await sendApiRequestReturnData(config)
}

export const deleteTariffRoleRequest = async (tariffRoleId) => {
    const session_url = process.env.VUE_APP_API_URL + 'tariffs/delete_tariff_role_by_id'

    const config = {
        method: 'delete',
        url: session_url,
        params: {
            tariff_role_id: tariffRoleId
        }
    }

    return await sendApiRequestReturnData(config)
}

export const addTariffRequest = async (tariff) => {
    const session_url = process.env.VUE_APP_API_URL + 'tariffs/add_new_tariff'

    const config = {
        method: 'post',
        url: session_url,
        data: {
            id: tariff.id,
            name: tariff.name,
            price: tariff.price,
            role_name: tariff.role_name,
            role_id: tariff.role_id,
            month: tariff.month,
            week: tariff.week,
            day: tariff.day
        }
    }

    return await sendApiRequestReturnData(config)
}

export const getAllTariffsRequest = async () => {
    const session_url = process.env.VUE_APP_API_URL + 'tariffs/get_all_tariffs'

    const config = {
        method: 'get',
        url: session_url
    }

    return await sendApiRequestReturnData(config)
}

export const updateTariffRequest = async (tariff) => {
    const session_url = process.env.VUE_APP_API_URL + 'tariffs/update_tariff_by_id'
    console.log('tariff ------- ', tariff)
    const config = {
        method: 'put',
        url: session_url,
        params: {
            tariff_id: tariff.id
        },
        data: {
            id: tariff.id,
            name: tariff.name,
            price: tariff.price,
            role_name: tariff.role_name,
            role_id: tariff.role_id,
            month: tariff.month,
            week: tariff.week,
            day: tariff.day
        }
    }

    return await sendApiRequestReturnData(config)
}

export const deleteTariffRequest = async (tariffId) => {
    const session_url = process.env.VUE_APP_API_URL + 'tariffs/delete_tariff_by_id'

    const config = {
        method: 'delete',
        url: session_url,
        params: {
            tariff_id: tariffId
        }
    }

    return await sendApiRequestReturnData(config)
}

export const getTariffsByRoleId = async (roleId) => {
    const session_url = process.env.VUE_APP_API_URL + 'tariffs/get_tariffs_by_role_id'

    const config = {
        method: 'get',
        url: session_url,
        params: {
            role_id: roleId
        }
    }

    return await sendApiRequestReturnData(config)
}

export const addTariffIncome = async (amount, label, receiver_balance_id, student_id, student_name, new_prepaid_balance, prepaid_income, tariff_id, tariff_name, additional_files) => {
    const session_url = process.env.VUE_APP_API_URL + 'transaction/add_real_income_tariff'

    const data = {
        transactions_purpose: "tariff_payment",
        amount: amount,
        label: label,
        receiver_balance_id: receiver_balance_id,
        student_id: student_id,
        student_name: student_name,
        new_prepaid_balance: new_prepaid_balance,
        prepaid_income: prepaid_income,
        tariff_id: tariff_id,
        tariff_name: tariff_name
    }

    const formData = new FormData()

    formData.append('real_income_tariff', JSON.stringify(data))

    additional_files.forEach((file) => {
        formData.append('additional_files', file)
    })

    const config = {
        method: 'post',
        url: session_url,
        data: formData
    }

    return await sendApiRequestReturnData(config)
}

export const getAllRealIncomeTariffs = async (studentId) => {
    const session_url = process.env.VUE_APP_API_URL + 'transaction/get_all_real_income_tariffs'

    const config = {
        method: 'get',
        url: session_url,
        params: {
            student_id: studentId
        }
    }

    return await sendApiRequestReturnData(config)
}

export const getPercentTrainingsWithAdditionalFilesInCurrentMonth = async () => {
    const session_url = process.env.VUE_APP_API_URL + 'trainings/get_percent_trainings_with_additional_files_in_current_month'

    const config = {
        method: 'get',
        url: session_url
    }

    return await sendApiRequestReturnData(config)
}

export const getCountStudentsWithOverdueTariffs = async () => {
    const session_url = process.env.VUE_APP_API_URL + 'student/get_count_students_with_overdue_tariffs'

    const config = {
        method: 'get',
        url: session_url
    }

    return await sendApiRequestReturnData(config)
}

export const deleteTariffIncome = async (transactionId) => {
    const session_url = process.env.VUE_APP_API_URL + 'transaction/delete_tariff_income'

    const config = {
        method: 'delete',
        url: session_url,
        params: {
            transaction_id: transactionId
        }
    }

    return await sendApiRequestReturnData(config)
}

export const getAssistantGroupsRequest = async (assistantId) => {
    const session_url = process.env.VUE_APP_API_URL + 'groups/get_assistants_groups'

    const config = {
        method: 'get',
        url: session_url,
        params: {
            assistant_id: assistantId
        }
    }

    return await sendApiRequest(config)
}


export const addTrainingElementRequest = async (trainingElement, addition_images) => {
    const session_url = process.env.VUE_APP_API_URL + 'training_elements/add_new_training_element'

    const form = new FormData()

    form.append('request', JSON.stringify(trainingElement))

    addition_images.forEach((image) => {
        form.append('addition_images', image)
    })

    const config = {
        method: 'post',
        url: session_url,
        data: form
    }

    return await sendApiRequestReturnData(config)
}

export const getAllTrainingElementsRequest = async (count, skip, filters = {}, query = '') => {
    const session_url = process.env.VUE_APP_API_URL + 'training_elements/get_all_training_elements'

    const config = {
        method: 'post',
        url: session_url,
        data: {
            count: count,
            skip: skip,
            filters: filters,
            query: query
        }
    }

    return await sendApiRequestReturnData(config)
}

export const deleteElementByIdRequest = async (id) => {
    const session_url = process.env.VUE_APP_API_URL + 'training_elements/delete_training_element_by_id'

    const config = {
        method: 'delete',
        url: session_url,
        params: {
            training_element_id: id
        }
    }

    return await sendApiRequestReturnData(config)
}

export const getStatisticsByElements = async () => {
    const session_url = process.env.VUE_APP_API_URL + 'training_elements/statistics_by_element_types'

    const config = {
        method: 'get',
        url: session_url,
    }

    return await sendApiRequestReturnData(config)
}

export const getElementByIdRequest = async (id) => {
    const session_url = process.env.VUE_APP_API_URL + 'training_elements/get_training_element_by_id'

    const config = {
        method: 'get',
        url: session_url,
        params: {
            training_element_id: id
        }
    }

    return await sendApiRequestReturnData(config)
}

export const createNewTrainingSchemaRequest = async (trainingSchema, file) => {
    const session_url = process.env.VUE_APP_API_URL + 'training_schemas/create_schema'
    console.log('trainingSchema ------- ', trainingSchema)

    const formData = new FormData()

    formData.append('training_schema', JSON.stringify(trainingSchema))

    formData.append('file', file)

    const config = {
        method: 'post',
        url: session_url,
        data: formData
    }

    return await sendApiRequestReturnData(config)
}

export const getAllTrainingSchemasRequest = async (count, skip, query) => {
    const session_url = process.env.VUE_APP_API_URL + 'training_schemas/get_all_schemas'

    const config = {
        method: 'get',
        url: session_url,
        params: {
            count: count,
            skip: skip,
            query: query
        }
    }

    return await sendApiRequestReturnData(config)
}

export const getSvgCodeOfSchema = async (filename) => {
    
    // const config = {
    //     method: 'get',
    //     url: process.env.VUE_APP_API_URL + 'static/' + filename,
    // }

    // /training_schemas/get_schema_svg
    
    const session_url = process.env.VUE_APP_API_URL + 'training_schemas/get_schema_svg'

    const config = {
        method: 'get',
        url: session_url,
        params: {
            filename: filename
        }
    }

    return await sendApiRequestReturnData(config)
}

export const deleteSchemaByIdRequest = async (id) => {
    const session_url = process.env.VUE_APP_API_URL + 'training_schemas/delete_schema_by_id'

    const config = {
        method: 'delete',
        url: session_url,
        params: {
            schema_id: id
        }
    }

    return await sendApiRequestReturnData(config)
}

export const updateSchemaByIdRequest = async (id, trainingSchema, file) => {
    const session_url = process.env.VUE_APP_API_URL + 'training_schemas/update_schema_by_id'

    const formData = new FormData()

    formData.append('training_schema', JSON.stringify(trainingSchema))

    formData.append('file', file)

    const config = {
        method: 'put',
        url: session_url,
        params: {
            schema_id: id
        },
        data: formData
    }

    return await sendApiRequestReturnData(config)
}

export const updateTrainingElementById = async (id, trainingElement, new_additional_images) => {
    const session_url = process.env.VUE_APP_API_URL + 'training_elements/update_training_element_by_id'

    const form = new FormData()

    console.log('trainingElement ------- ', trainingElement)

    form.append('request', JSON.stringify(trainingElement))

    new_additional_images.forEach((image) => {
        form.append('addition_images', image)
    })

    const config = {
        method: 'put',
        url: session_url,
        params: {
            training_element_id: id
        },
        data: form
    }

    return await sendApiRequestReturnData(config)
}

export const getSchemaById = async (id) => {
    const session_url = process.env.VUE_APP_API_URL + 'training_schemas/get_schema_by_id'

    const config = {
        method: 'get',
        url: session_url,
        params: {
            schema_id: id
        }
    }

    return await sendApiRequestReturnData(config)
}

export const addTrainingRequest = async (training, additional_images) => {
    const session_url = process.env.VUE_APP_API_URL + 'training_constructor/add_new_training'
    
    const config = {
        method: 'post',
        url: session_url,
        data: training
    }

    return await sendApiRequestReturnData(config)
}

export const addNewTrainingSummary = async (trainingSummaryObject) => {
    const session_url = process.env.VUE_APP_API_URL + 'training_summary/add_summary'

    const config = {
        method: 'post',
        url: session_url,
        data: trainingSummaryObject
    }

    return await sendApiRequestReturnData(config)
}

export const getAllSummaries = async (count = 20, skip = 0, filters = {}, query = '') => {
    const session_url = process.env.VUE_APP_API_URL + 'training_summary/get_all_summaries'

    const config = {
        method: 'post',
        url: session_url,
        data: {
            count: count,
            skip: skip,
            filters: filters,
            query: query
        }
    }

    return await sendApiRequestReturnData(config)
}

export const getTrainingSummaryById = async (id) => {
    const session_url = process.env.VUE_APP_API_URL + 'training_summary/get_summary_by_id'

    const config = {
        method: 'get',
        url: session_url,
        params: {
            summary_id: id
        }
    }

    return await sendApiRequestReturnData(config)
} 

export const getSummaryById = async (id) => {
    const session_url = process.env.VUE_APP_API_URL + 'training_summary/get_summary_by_id'

    const config = {
        method: 'get',
        url: session_url,
        params: {
            summary_id: id
        }
    }

    return await sendApiRequestReturnData(config)
}

export const deleteSummaryById = async (id) => {
    const session_url = process.env.VUE_APP_API_URL + 'training_summary/delete_summary'

    const config = {
        method: 'delete',
        url: session_url,
        params: {
            summary_id: id
        }
    }

    return await sendApiRequestReturnData(config)
}

export const updateSummaryById = async (id, newSummary) => {
    const session_url = process.env.VUE_APP_API_URL + 'training_summary/update_summary'

    const config = {
        method: 'put',
        url: session_url,
        params: {
            summary_id: id
        },
        data: newSummary
    }

    return await sendApiRequestReturnData(config)
}

export const getTrainingsSummaryCount = async () => {
    const session_url = process.env.VUE_APP_API_URL + 'training_summary/get_summary_count'

    const config = {
        method: 'get',
        url: session_url
    }

    return await sendApiRequestReturnData(config)
}

export const addTrainingSummaryProgram = async (trainingSummaryProgramObject) => {
    console.log('trainingSummaryProgramObject ------- ', trainingSummaryProgramObject)
    const session_url = process.env.VUE_APP_API_URL + 'training_program/add_new_training_program'

    const config = {
        method: 'post',
        url: session_url,
        data: trainingSummaryProgramObject
    }

    return await sendApiRequestReturnData(config)
}

export const getAllTrainingPrograms = async (count = 20, skip = 0, query = '') => {
    const session_url = process.env.VUE_APP_API_URL + 'training_program/get_programs_by_name'

    const config = {
        method: 'get',
        url: session_url,
        params: {
            count: count,
            skip: skip,
            name: query
        }
    }

    return await sendApiRequestReturnData(config)
}

export const deleteTrainingProgramById = async (id) => {
    const session_url = process.env.VUE_APP_API_URL + 'training_program/delete_training_program_by_id'

    const config = {
        method: 'delete',
        url: session_url,
        params: {
            training_program_id: id
        }
    }

    return await sendApiRequestReturnData(config)
}

export const getTrainingProgramById = async (id) => {
    const session_url = process.env.VUE_APP_API_URL + 'training_program/get_training_program_by_id'

    const config = {
        method: 'get',
        url: session_url,
        params: {
            training_program_id: id
        }
    }

    return await sendApiRequestReturnData(config)
}

export const updateTrainingProgramById = async (id, newTrainingProgram) => {
    const session_url = process.env.VUE_APP_API_URL + 'training_program/update_training_program_by_id'

    const config = {
        method: 'put',
        url: session_url,
        params: {
            training_program_id: id
        },
        data: newTrainingProgram
    }

    return await sendApiRequestReturnData(config)
}

export const getSummariesByMicrocycleId = async (id, count = 20, skip = 0) => {
    const session_url = process.env.VUE_APP_API_URL + 'training_summary/get_summaries_by_microcycle_id'

    const config = {
        method: 'get',
        url: session_url,
        params: {
            microcycle_id: id,
            count: count,
            skip: skip
        }
    }

    return await sendApiRequestReturnData(config)
}

export const addSummaryToProgram = async (program_id, program_name, microcycle_id, microcycle_name, mesocycle_id, mesocycle_name, summary_id) => {
    const session_url = process.env.VUE_APP_API_URL + 'training_summary/add_summary_to_program'

    const config = {
        method: 'get',
        url: session_url,
        params: {
            program_id: program_id,
            program_name: program_name,
            microcycle_id: microcycle_id,
            microcycle_name: microcycle_name,
            mesocycle_id: mesocycle_id,
            mesocycle_name: mesocycle_name,
            summary_id: summary_id
        }
    }

    return await sendApiRequestReturnData(config)
}

export const countTrainingPrograms = async () => {
    const session_url = process.env.VUE_APP_API_URL + 'training_program/count_training_programs'

    const config = {
        method: 'get',
        url: session_url
    }

    return await sendApiRequestReturnData(config)
}

export const countSummariesWithMicrocycleId = async () => {
    const session_url = process.env.VUE_APP_API_URL + 'training_summary/count_summaries_with_microcycles_id'

    const config = {
        method: 'get',
        url: session_url
    }

    return await sendApiRequestReturnData(config)
}

export const countSummariesInCurrentProgram = async (id) => {
    const session_url = process.env.VUE_APP_API_URL + 'training_program/count_trainings_in_current_program'

    const config = {
        method: 'get',
        url: session_url,
        params: {
            training_program_id: id
        }
    }

    return await sendApiRequestReturnData(config)
}

export const getProgramsByName = async (name) => {
    const session_url = process.env.VUE_APP_API_URL + 'training_program/get_programs_by_name'

    const config = {
        method: 'get',
        url: session_url,
        params: {
            name: name,
            count: 20,
            skip: 0
        }
    }

    return await sendApiRequestReturnData(config)
}

export const addTrainingProgramsToGroup = async (groupId, trainingProgramsIds) => {
    const session_url = process.env.VUE_APP_API_URL + 'training_program/add_group_to_programs'

    const config = {
        method: 'post',
        url: session_url,
        data: {
            training_program_ids: trainingProgramsIds,
            group_id: groupId
        }
    }

    return await sendApiRequest(config)
}

export const getProgramsByGroupId = async (groupId) => {
    const session_url = process.env.VUE_APP_API_URL + 'groups/get_programs_by_group_id'

    const config = {
        method: 'get',
        url: session_url,
        params: {
            group_id: groupId
        }
    }

    return await sendApiRequestReturnData(config)
}

export const deleteProgramsFromGroup = async (groupId, trainingProgramsIds) => {
    const session_url = process.env.VUE_APP_API_URL + 'training_program/delete_group_from_programs'

    const config = {
        method: 'post',
        url: session_url,
        data: {
            training_program_ids: trainingProgramsIds,
            group_id: groupId
        }
    }

    return await sendApiRequest(config)
}


export const addStandardRequest = async (standard) => {
    const session_url = process.env.VUE_APP_API_URL + 'standards/add_standard'

    const config = {
        method: 'post',
        url: session_url,
        data: standard
    }

    return await sendApiRequestReturnData(config)
}

export const getAllStandardsRequest = async () => {
    const session_url = process.env.VUE_APP_API_URL + 'standards/get_standards'

    const config = {
        method: 'get',
        url: session_url
    }

    return await sendApiRequestReturnData(config)
}

export const updateStandardById = async (id, newStandard) => {
    const session_url = process.env.VUE_APP_API_URL + 'standards/update_standard'

    const config = {
        method: 'put',
        url: session_url,
        params: {
            standard_id: id
        },
        data: newStandard
    }

    return await sendApiRequestReturnData(config)
}

export const deleteStandardById = async (id) => {
    const session_url = process.env.VUE_APP_API_URL + 'standards/delete_standard'

    const config = {
        method: 'delete',
        url: session_url,
        params: {
            standard_id: id
        }
    }

    return await sendApiRequestReturnData(config)
}

export const getAllStudentStandardsByStudentId = async (studentId) => {
    const session_url = process.env.VUE_APP_API_URL + 'player_full_card/get_all_student_standards_by_student_id'

    const config = {
        method: 'get',
        url: session_url,
        params: {
            student_id: studentId
        }
    }

    return await sendApiRequestReturnData(config)
}


export const addStandardGroup = async (newGroup) => {
    const session_url = process.env.VUE_APP_API_URL + 'standards/add_standard_group'

    const config = {
        method: 'post',
        url: session_url,
        data: newGroup
    }

    return await sendApiRequestReturnData(config)
}

export const updateStandardGroupById = async (id, newGroup) => {
    const session_url = process.env.VUE_APP_API_URL + 'standards/update_standard_group'

    const config = {
        method: 'put',
        url: session_url,
        params: {
            group_id: id
        },
        data: newGroup
    }

    return await sendApiRequestReturnData(config)
}

export const deleteStandardGroupById = async (id) => {
    const session_url = process.env.VUE_APP_API_URL + 'standards/delete_standard_group'

    const config = {
        method: 'delete',
        url: session_url,
        params: {
            group_id: id
        }
    }

    return await sendApiRequestReturnData(config)
}

export const getAllStandardGroups = async () => {
    const session_url = process.env.VUE_APP_API_URL + 'standards/get_all_standard_groups'

    const config = {
        method: 'get',
        url: session_url
    }

    return await sendApiRequestReturnData(config)
}

export const addPlayerStandard = async (standardResult) => {
    const session_url = process.env.VUE_APP_API_URL + 'player_full_card/add_player_standard'

    const config = {
        method: 'post',
        url: session_url,
        data: standardResult
    }

    return await sendApiRequest(config)
}

export const updatePlayerStandardByReportId = async (reportId, standardResult) => {
    const session_url = process.env.VUE_APP_API_URL + 'player_full_card/update_player_standard_by_report_id'

    const config = {
        method: 'put',
        url: session_url,
        data: standardResult,
        params: {
            report_id: reportId
        }
    }

    return await sendApiRequest(config)
} 


export const getElementsByRadarWeights = async (weights, base_standard_ids = null) => {
    const session_url = process.env.VUE_APP_API_URL + 'training_elements/get_elements_by_radar_weights'

    const config = {
        method: 'post',
        url: session_url,
        data: {
            radar_weights: weights,
            base_standard_ids: base_standard_ids
        }
    }

    return await sendApiRequestReturnData(config)
}

export const getElementTrainingsCompletedCount = async (elementId) => {
    const session_url = process.env.VUE_APP_API_URL + 'trainings/get_element_trainings_completed_count'

    const config = {
        method: 'get',
        url: session_url,
        params: {
            element_id: elementId
        }
    }

    return await sendApiRequestReturnData(config)
}

export const getElementTrainingsCompleted = async (elementId) => {
    const session_url = process.env.VUE_APP_API_URL + 'trainings/get_element_trainings_completed'

    const config = {
        method: 'get',
        url: session_url,
        params: {
            element_id: elementId
        }
    }

    return await sendApiRequestReturnData(config)
}

export const getPlayersThatCompleteStandardByTraining = async (elementId, trainingId) => {
    const session_url = process.env.VUE_APP_API_URL + 'player_full_card/get_players_that_complete_standard_by_training'

    const config = {
        method: 'get',
        url: session_url,
        params: {
            training_id: trainingId,
            base_standard_id: elementId
        }
    }

    return await sendApiRequestReturnData(config)
}


export const getAllStudentStandardByStudentIdAndStandardId = async (studentId, standardId) => {
    const session_url = process.env.VUE_APP_API_URL + 'player_full_card/get_all_student_standard_by_student_id_and_standard_id'

    const config = {
        method: 'get',
        url: session_url,
        params: {
            student_id: studentId,
            base_standard_id: standardId
        }
    }

    return await sendApiRequestReturnData(config)
}

export const getObjectiveRadarForStudent = async (studentId) => {
    const session_url = process.env.VUE_APP_API_URL + 'player_full_card/get_objective_radar_for_student'

    const config = {
        method: 'get',
        url: session_url,
        params: {
            student_id: studentId
        }
    }

    return await sendApiRequestReturnData(config)
}

export const getAnalyticsByPlayersInClub = async (data) => {
    const session_url = process.env.VUE_APP_API_URL + 'analytics/get_analytics_by_players_in_club'

    const config = {
        method: 'post',
        url: session_url,
        data: data
    }

    return await sendApiRequestReturnData(config)
}


export const getAllSchemasCount = async () => {
    const session_url = process.env.VUE_APP_API_URL + 'training_schemas/get_all_schemas_count'

    const config = {
        method: 'get',
        url: session_url,
    }

    return await sendApiRequestReturnData(config)
}

export const getObjectiveScoreSettings = async () => {
    const session_url = process.env.VUE_APP_API_URL + 'settings/get_objective_score_settings'

    const config = {
        method: 'get',
        url: session_url
    }

    return await sendApiRequestReturnData(config)
}

export const parsePalarXlsNew = async (file1, file2, gameFile) => {
    const formData = new FormData()

    //multipart/form-data

    formData.append('first_time', file1)
    formData.append('second_time', file2)
    formData.append('game', gameFile)

    console.log('first_time ------- ', file1)
    console.log('second_time ------- ', file2)
    console.log('game ------- ', gameFile)

    const config = {
        method: 'post',
        url: process.env.VUE_APP_API_URL + 'training_summary_addons/parse_palar_xls_new',
        data: formData,
        responseType: 'blob',
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    }

    return await sendApiRequest(config)
}

export const getStudentsWhichAttendedTraining = async (trainingDate, groupId) => {
    const session_url = process.env.VUE_APP_API_URL + 'student/get_students_by_attended_training'

    const config = {
        method: 'get',
        url: session_url,
        params: {
            training_date: trainingDate,
            group_id: groupId
        }
    }

    return await sendApiRequest(config)
}

export const getStudentsWhichMissedTraining = async (trainingDate, groupId) => {
    const session_url = process.env.VUE_APP_API_URL + 'student/get_students_by_missed_training'

    const config = {
        method: 'get',
        url: session_url,
        params: {
            training_date: trainingDate,
            group_id: groupId
        }
    }

    return await sendApiRequest(config)
}

export const updateObjectiveScoreSettings = async (goalkeeperSettings, playerFieldSettings) => {
    const session_url = process.env.VUE_APP_API_URL + 'settings/update_objective_score_settings'

    const config = {
        method: 'post',
        url: session_url,
        data: {
            goalkeeper_settings: goalkeeperSettings,
            player_field_settings: playerFieldSettings
        }
    }

    return await sendApiRequestReturnData(config)
}

export const getScoreSettings = async () => {
    const session_url = process.env.VUE_APP_API_URL + 'settings/get_score_settings'

    const config = {
        method: 'get',
        url: session_url
    }

    return await sendApiRequestReturnData(config)
}

export const getTrainingById = async (id) => {
    const session_url = process.env.VUE_APP_API_URL + 'trainings/get_training_by_id'

    const config = {
        method: 'get',
        url: session_url,
        params: {
            training_id: id
        }
    }

    return await sendApiRequestReturnData(config)
}


export const getPlayerFullCardByStudentId = async (student_id) => {
    const session_url = process.env.VUE_APP_API_URL + 'player_full_card/get_player_full_card_by_student_id'

    const config = {
        method: 'get',
        url: session_url,
        params: {
            student_id: student_id
        }
    }

    return await sendApiRequestReturnData(config)
}

export const updateAdminCard = async (adminCard) => {
    const session_url = process.env.VUE_APP_API_URL + 'admin/update_admin'

    const config = {
        method: 'put',
        url: session_url,
        params: {
            admin_id: adminCard.admin_id
        },
        data: adminCard
    }

    console.log('adminCard -------- ', adminCard)

    return await sendApiRequestReturnData(config)
}

export const addNewAdmin = async (adminCard) => {
    const session_url = process.env.VUE_APP_API_URL + 'admin/add_new_admin_for_admin'

    const config = {
        method: 'post',
        url: session_url,
        data: adminCard
    }

    return await sendApiRequestReturnData(config)
}

export const deleteAdminRequest = async (adminId) => {
    const session_url = process.env.VUE_APP_API_URL + 'admin/delete_admin'

    const config = {
        method: 'delete',
        url: session_url,
        params: {
            admin_id: adminId
        }
    }

    return await sendApiRequestReturnData(config)
}

export const addNewSchemaCategory = async (category) => {
    const session_url = process.env.VUE_APP_API_URL + 'training_schemas/add_new_schema_category'

    const config = {
        method: 'post',
        url: session_url,
        data: category
    }

    return await sendApiRequestReturnData(config)
}

export const getSchemaCategoryById = async (id) => {
    const session_url = process.env.VUE_APP_API_URL + 'training_schemas/get_schema_category_by_id'

    const config = {
        method: 'get',
        url: session_url,
        params: {
            schema_category_id: id
        }
    }

    return await sendApiRequestReturnData(config)
}

export const getAllSchemaCategories = async () => {
    const session_url = process.env.VUE_APP_API_URL + 'training_schemas/get_all_schema_categories'

    const config = {
        method: 'get',
        url: session_url,
        params: {
            count: 1000,
            skip: 0,
            query: ''
        }
    }

    return await sendApiRequestReturnData(config)
}

export const updateSchemaCategoryById = async (id, category) => {
    const session_url = process.env.VUE_APP_API_URL + 'training_schemas/update_schema_category_by_id'

    const config = {
        method: 'put',
        url: session_url,
        params: {
            schema_category_id: id
        },
        data: category
    }

    return await sendApiRequestReturnData(config)
}

export const deleteSchemaCategoryById = async (id) => {
    const session_url = process.env.VUE_APP_API_URL + 'training_schemas/delete_schema_category_by_id'

    const config = {
        method: 'delete',
        url: session_url,
        params: {
            schema_category_id: id
        }
    }

    return await sendApiRequestReturnData(config)
}

export const getSchemasByCategoryId = async (id, count, skip) => {
    const session_url = process.env.VUE_APP_API_URL + 'training_schemas/get_schemas_by_category_id'

    const config = {
        method: 'get',
        url: session_url,
        params: {
            category_id: id,
            count: count,
            skip: skip
        }
    }

    return await sendApiRequestReturnData(config)
}